// Copyright (c) StrangeBee 2023

import { Form } from 'antd';
import React, { ReactElement } from 'react';
import { WidgetTextOutput } from 'thehive-sdk';
import { useDashboard } from '@Hooks/useDashboard';
import WidgetDrawer from '@Organisms/Dashboard/WidgetManage/WidgetDrawer';
import { TextForm, TextValues } from '@Organisms/Dashboard/WidgetManage/Text/TextForm';
import { getNewTextWidget } from './NewTextDrawer';

interface TextDrawerProps {
    data: WidgetTextOutput;
}

const TextDrawer = ({ data }: TextDrawerProps): ReactElement => {
    const [form] = Form.useForm();
    const { editWidget } = useDashboard();

    const onFinish = (text: TextValues): void => {
        const widgetId = data.id;
        const widgetText: WidgetTextOutput = {
            ...getNewTextWidget(text),
            id: widgetId,
        };

        editWidget(widgetText, widgetId);
        form.resetFields();
    };

    return (
        <WidgetDrawer form={form} widgetType="text">
            {(toggleDrawer, { setFieldsTouched }) => (
                <TextForm
                    form={form}
                    onFinish={(values) => {
                        onFinish(values);
                        toggleDrawer();
                        setFieldsTouched(false);
                    }}
                    onCancel={() => {
                        toggleDrawer();
                        form.resetFields();
                        setFieldsTouched(false);
                    }}
                    onChange={() => {
                        setFieldsTouched(true);
                    }}
                    defaultValues={data}
                />
            )}
        </WidgetDrawer>
    );
};

export default TextDrawer;
